import { useSessionUser } from "hooks/useSession";
import * as React from "react";
import { UserAvatar } from "components/common/UserAvatar";
import { UserProfileInfoProps } from "./UserProfileInfo.types";

export const UserProfileInfo: React.FC<UserProfileInfoProps> = ({
  className = "",
  showEmail = true,
  variant = "default",
}) => {
  const { session: profile } = useSessionUser();
  const fullName = profile ? `${profile.first_name} ${profile.last_name}` : "";
  const email = profile?.email ?? "";

  if (variant === "compact") {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <UserAvatar size="md" />
        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium text-foreground truncate">{fullName}</div>
          {showEmail && <div className="text-xs text-muted-foreground truncate">{email}</div>}
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 px-1 py-1.5 text-left text-sm ${className}`}>
      <UserAvatar size="md" />
      <div className="grid flex-1 text-left text-sm leading-tight">
        <span className="truncate font-medium text-foreground">{fullName}</span>
        {showEmail && <span className="truncate text-xs text-muted-foreground">{email}</span>}
      </div>
    </div>
  );
};
